import { render } from "./PopUpCreateCalendar.vue?vue&type=template&id=347dac8e"
import script from "./PopUpCreateCalendar.vue?vue&type=script&lang=js"
export * from "./PopUpCreateCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__